import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import styles from './ColorBox.module.scss';
import cn from 'classnames';
import useQuery from '../../hooks/useQuery';
import { useSearchParams } from 'react-router-dom';
const ColorCircle = ({ src, isActive, name, onClick }) => {
    const onColorClick = useCallback(() => {
        onClick && onClick({ color: name });
    }, [onClick, name]);
    return (_jsx("div", Object.assign({ title: name, onClick: onColorClick, className: cn(styles.wrapper, 'd-flex flex-column', isActive && styles.isActive) }, { children: _jsx("img", { src: src, alt: "color", className: styles.color }) }), src));
};
const ColorBox = ({ colors, onChange, title }) => {
    const query = useQuery();
    const [params, setParams] = useSearchParams();
    const currentFilter = query[title.toLocaleLowerCase()];
    const handleColorFilter = (value, name) => {
        const colorArray = currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.split(',');
        const filterExitsts = (colorArray === null || colorArray === void 0 ? void 0 : colorArray.includes(name)) || false;
        if (!filterExitsts) {
            onChange && onChange(value);
        }
        else {
            const updatedFilters = colorArray.filter((el) => el !== name);
            params.set('color', String(updatedFilters));
            setParams(params);
        }
    };
    const colorData = useMemo(() => colors.map(({ name, src }) => ({
        name,
        src,
        isActive: currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.split(',').includes(name),
        onClick: (value) => handleColorFilter(value, name)
    })), [colors, onChange, currentFilter]);
    return (_jsx("div", Object.assign({ className: styles.element }, { children: colorData.map((color, index) => (_jsx(ColorCircle, Object.assign({}, color), index))) })));
};
export default ColorBox;
